import { render, staticRenderFns } from "./AppSidebar.vue?vue&type=template&id=12e06363&scoped=true"
import script from "./AppSidebar.vue?vue&type=script&lang=ts"
export * from "./AppSidebar.vue?vue&type=script&lang=ts"
import style0 from "./AppSidebar.vue?vue&type=style&index=0&id=12e06363&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e06363",
  null
  
)

export default component.exports